import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import { ModalProps } from '@common/components/modal/_components/modal.component';
import { SavedCreditCard } from '@models/Account';
import { OptionsViewModel } from '@models/common.models';
import { PaymentPurpose, PaymentViewModel } from '@models/Payment';
import { ServiceWorkOrderViewModel, SwoPaymentViewModel } from '@models/ServiceWorkOrder';

import { HostedPayment } from 'src/payment/_components/gateway/hosted-payment.container';

export interface ServiceFeePaymentComponentProperties extends RouteComponentProps<{ id: string }> {
  readonly affiliatedAccounts?: OptionsViewModel[];
  readonly contractEndDate?: Date;
  readonly savedCreditCards?: SavedCreditCard[];
  readonly serviceWorkOrderVM: ServiceWorkOrderViewModel;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly initialize: (swoId: number) => void;
  readonly submit: (
    serviceWorkOrderVM: ServiceWorkOrderViewModel,
    payment?: SwoPaymentViewModel,
    firstBilling?: OptionsViewModel,
    laterBills?: OptionsViewModel
  ) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
}

export class ServiceFeePaymentComponent extends React.Component<ServiceFeePaymentComponentProperties> {
  public componentDidMount(): void {
    this.props.initialize(+this.props.match.params.id);
  }

  public render(): JSX.Element {
    if (
      !this.props.serviceWorkOrderVM ||
      (this.props.serviceWorkOrderVM && this.props.serviceWorkOrderVM.serviceFeeBalance <= 0)
    ) {
      return <></>;
    }

    if (
      this.props.serviceWorkOrderVM.serviceFeeBalance == null ||
      this.props.serviceWorkOrderVM.serviceFeeBalance <= 0
    ) {
      this.renderEmailModal();
    }

    return (
      <>
        <h2>Payment</h2>
        <HostedPayment
          swoId={this.props.serviceWorkOrderVM.id}
          affiliatedAccounts={this.props.affiliatedAccounts}
          contractEndDate={this.props.contractEndDate}
          paymentPurpose={PaymentPurpose.SWO}
          totalPrice={this.props.serviceWorkOrderVM.serviceFeeBalance}
          savedCreditCards={this.props.savedCreditCards}
          submit={this.handleSubmit}
          submitButtonRef={this.props.buttonRef}
        />
      </>
    );
  }

  private handleSubmit = (model: PaymentViewModel) => {
    let firstBilling: OptionsViewModel = {} as OptionsViewModel;
    if (model && model.paymentDemandLetterInitial && model.paymentDemandLetterInitial.contractBillTo) {
      firstBilling = { id: +model.paymentDemandLetterInitial.contractBillTo } as OptionsViewModel;
    }
    const swoPaymentModel: SwoPaymentViewModel = {
      amount: model.paymentAmountInitial,
      creditCard: model.paymentCreditCardInitial
    };

    this.props.submit(this.props.serviceWorkOrderVM, swoPaymentModel, firstBilling);
  };

  private renderEmailModal() {
    // TODO: REPLACE COMPONENT FOR RESALE EMAIL
    // this.props.toggleModal(
    //   {
    //   title: 'Email Resale',
    //   saveLabel: 'Done',
    //   hideClose: true,
    //   component: ContractResaleEmail,
    //   saveCallback: this.handleSendEmail,
    //   childProps: { id: this.props.contractId ? this.props.contractId : null }
    //   }
    // );
  }
}



// WEBPACK FOOTER //
// ./src/service-work-order/_components/service-work-order-create/service-fee-payment-step/service-fee-payment.component.tsx